<template>
	<div>
		<b-modal
			v-model="localModal"
			id="publicAvailabilityModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			size="lg"
			@hide="$emit('hide')"
		>
			<header
				class="d-flex align-items-center justify-content-between viewcon-border-bottom head"
			>
				<div class="font-lato fw-500 fs-18 color-black">
					Public Availability
				</div>
				<div @click="closeModal()">
					<img
						class="rotate-on-hover pointer"
						src="../../../assets/common-icons/blue-cross.svg"
						alt=""
					/>
				</div>
			</header>

			<b-overlay :show="saveLoading" rounded="sm">
				<div class="p-3">
					<!-- Public Availability Toggle -->
					<b-row>
						<b-col>
							<div class="d-flex mt-3 align-items-center">
								<span class="viewcon-option-clr"
									>Public Availability <span class="asterik">*</span></span
								>
								<b-form-radio-group
									class="ml-3"
									:options="options"
									v-model="clone.publicAvailability"
									value-field="item"
									text-field="name"
									disabled-field="notEnabled"
									size="sm"
									@change="onPublicAvailabilityChange"
								></b-form-radio-group>
							</div>
						</b-col>
					</b-row>
					<b-row v-if="leaderboardAdminAccess && clone.publicAvailability">
						<b-col>
							<div class="topDiv mt-3">
								<label class="viewcon-label"
									>Tagline <span class="asterik">*</span>&nbsp;</label
								>
								<b-form-input
									class="viewcon-inputField"
									id="input-1"
									placeholder="Enter here"
									v-model="clone.tagline"
									type="text"
									:class="{
										error: $v.clone.tagline && $v.clone.tagline.$error,
									}"
								></b-form-input>
								<div
									v-if="
										$v.clone.tagline &&
											$v.clone.tagline.$dirty &&
											!$v.clone.tagline.required
									"
									style="position: absolute; top: 6px; right: 152px; background: var(--bg-white);"
									v-b-popover.hover.top.v-danger="{
										content: 'Tagline is required',
									}"
								>
									<img src="../../../assets/deletepopupicon.svg" alt="" />
								</div>
								<div
									style="    position: absolute;
    right: 10px;
    top: 6px;"
								>
									<b-button
										class="floating-button"
										@click="fetchTagline"
										style="    padding: 2px 7px;
    font-size: 12px;border-radius: 50px;"
										:disabled="loadingShow"
									>
										<slot
											>Write with Hire3x
											<img src="@/assets/Ai.svg" alt="" class="mr-1 pointer"
										/></slot>
									</b-button>
									<b-spinner
										v-if="loadingShow"
										small
										style="    position: absolute;
    left: 45%;
    top: 5px;"
									>
									</b-spinner>
								</div>
							</div>
						</b-col>
					</b-row>
					<!-- Pricing & Leaderboard (only when public and leaderboard admin) -->
					<div
						class="pricing-container mt-3"
						v-if="leaderboardAdminAccess && clone.publicAvailability"
					>
						<b-row class="access-switch mx-0 flex-column">
							<div class="d-flex align-items-baseline">
								<span class="fw-500 fs-16 color-black mr-2">Set Pricing</span>
								<b-form-checkbox
									name="role-check-button"
									switch
									v-model="clone.setPricing"
									@change="hideshowPricingDetails"
								></b-form-checkbox>
							</div>
							<hr style="border-top: 1px solid #d0d5dd80;" class="my-2 w-100" />
							<div class="d-flex align-items-center">
								<b-col class="pl-0">
									<div class="topDiv mt-3">
										<label class="viewcon-label" v-if="clone.setPricing"
											>List Price(Rs.) &nbsp;<span class="asterik"
												>*</span
											></label
										>
										<b-form-input
											class="viewcon-inputField"
											placeholder="List Price"
											v-model.number="$v.clone.listPrice.$model"
											:class="{
												error: $v.clone.listPrice.$error,
												'test-disable-color': !clone.setPricing,
											}"
											:disabled="!clone.setPricing"
											type="number"
										></b-form-input>
										<div
											style="position: absolute; top: 4px; right: 12px; background: var(--bg-white);"
											v-if="
												$v.clone.listPrice.$dirty &&
													!$v.clone.listPrice.required
											"
											v-b-popover.hover.top.v-danger="{ content: 'Required' }"
										>
											<img src="../../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 4px; right: 12px; background: var(--bg-white);"
											v-if="
												$v.clone.listPrice.$dirty && !$v.clone.listPrice.between
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Must be between 0 and 100000',
											}"
										>
											<img src="../../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 4px; right: 12px; background: var(--bg-white);"
											v-if="
												$v.clone.listPrice.$dirty &&
													!$v.clone.listPrice.maxFiveDecimals
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Must have at most 5 decimal places',
											}"
										>
											<img src="../../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
								<b-col class="pr-0">
									<div class="topDiv mt-3">
										<label class="viewcon-label" v-if="clone.setPricing"
											>Discount(Rs.)</label
										>
										<b-form-input
											class="viewcon-inputField"
											placeholder="Discount"
											:value="
												clone.setPricing && clone.discountAmount === null
													? 0
													: clone.discountAmount
											"
											@input="
												(v) => {
													$v.clone.discountAmount.$model =
														v === '' ? null : Number(v);
												}
											"
											:class="{
												error: $v.clone.discountAmount.$error,
												'test-disable-color': !clone.setPricing,
											}"
											:disabled="!clone.setPricing"
											type="number"
										></b-form-input>
										<div
											style="position: absolute; top: 4px; right: 12px; background: var(--bg-white);"
											v-if="
												$v.clone.discountAmount.$dirty &&
													!$v.clone.discountAmount.notGreaterThanList
											"
											v-b-popover.hover.top.v-danger="{
												content:
													'Discount price cannot exceed or be equal than list price',
											}"
										>
											<img src="../../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 4px; right: 12px; background: var(--bg-white);"
											v-if="!$v.clone.discountAmount.minValue"
											v-b-popover.hover.top.v-danger="{
												content: 'Discount Price Cannot be negative number',
											}"
										>
											<img src="../../../assets/deletepopupicon.svg" alt="" />
										</div>
										<div
											style="position: absolute; top: 40px;"
											class="fw-500 fs-10 color-7a7a7a fam-lato position-absolute"
										>
											Discount Price should be lesser than List price
										</div>
										<div
											style="position: absolute; top: 4px; right: 12px; background: var(--bg-white);"
											v-if="
												$v.clone.discountAmount.$dirty &&
													!$v.clone.discountAmount.maxFiveDecimals
											"
											v-b-popover.hover.top.v-danger="{
												content: 'Must have at most 5 decimal places',
											}"
										>
											<img src="../../../assets/deletepopupicon.svg" alt="" />
										</div>
									</div>
								</b-col>
							</div>
						</b-row>

						<template v-if="clone.setPricing">
							<section class="mt-3">
								<div class="d-flex align-items-center justify-content-between">
									<div class="fw-500 font-lato fs-14 color-344054">
										List Price
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹ {{ clone.listPrice || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Discount
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹{{ clone.discountAmount || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Final Price
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										₹{{ priceAfterDiscount || 0 }}
									</div>
								</div>
								<div
									class="d-flex align-items-center justify-content-between mt-1"
								>
									<div class="fw-500 font-lato fs-14 color-344054">
										Payment Gateway Charges
									</div>
									<div class="fw-500 font-mont fs-15 color-333333">
										{{ gatewayPercent }}%
									</div>
								</div>
							</section>
							<hr />
							<div
								class="d-flex align-items-center justify-content-between mt-1"
							>
								<div class="fw-600 font-lato fs-14 color-333333">
									Final Amount Receivable
								</div>
								<div class="fw-700 font-mont fs-16 color-333333">
									₹{{ finalReceivable || 0 }}
								</div>
							</div>
						</template>

						<!-- Add to Leaderboard (test mode only) -->
						<b-row
							v-if="mode !== 'project'"
							class="mt-3 access-switch align-items-center"
						>
							<b-col>
								<b-form-checkbox
									name="role-check-button"
									class="mt-3"
									switch
									v-model="clone.leaderboard"
									@change="onLeaderboardChange"
								>
									{{
										mode === "project"
											? "Add Project to Leaderboard"
											: "Add Assessment to Leaderboard"
									}}
								</b-form-checkbox>
							</b-col>
							<b-col>
								<div class="topDiv mt-3">
									<span
										class="viewcon-label"
										style="z-index: 1;"
										v-if="clone.leaderboard"
										>Leaderboard category<span class="asterik">*</span></span
									>
									<div
										ref="lb-dropdown-button"
										@click="
											clone.leaderboard &&
												(openLeaderBoardDropdown = !openLeaderBoardDropdown)
										"
										class="viewcon-select d-flex justify-content-between relativeclass"
										:class="{
											'disabled-text test-disable-color viewicon-select-disable cursor-disabled': !clone.leaderboard,
											error:
												clone.leaderboard &&
												$v.clone.leaderboardCategory.$error,
										}"
									>
										<span
											:class="
												!clone.leaderboardCategory ? '' : 'viewcon-option-clr'
											"
											class="text-truncate"
											>{{
												!clone.leaderboardCategory
													? "Select Leaderboard Category"
													: leaderBoardoptions.find(
															(c) => c.value == clone.leaderboardCategory
													  ).text
											}}</span
										>
										<span v-if="!openLeaderBoardDropdown"
											><img
												src="../../../assets/carrotdown.svg"
												alt=""
												class="mr-1"
										/></span>
										<span v-else
											><img
												src="../../../assets/uparrow.svg"
												alt=""
												class="mr-1"
										/></span>
									</div>
									<div
										v-if="openLeaderBoardDropdown"
										class="bct-checkboxcontainer pointer"
										ref="lb-dropdown"
										v-closable="{
											exclude: ['lb-dropdown-button', 'lb-dropdown'],
											handler: 'closeLeaderBoardDropdown',
										}"
									>
										<b-form-group class="qb-dd-group-ct">
											<b-form-radio-group
												class="bct-checboxtext radio-drp-dwn"
												:options="leaderBoardoptions"
												v-model="clone.leaderboardCategory"
												@change="closeLeaderBoardDropdown"
												buttons
												stacked
											>
											</b-form-radio-group>
										</b-form-group>
									</div>
								</div>
							</b-col>
						</b-row>
					</div>

					<!-- Set Configuration (test mode only) -->
					<b-row
						class="mt-2"
						style="height: 32px;"
						v-if="mode === 'test' && clone.publicAvailability"
					>
						<b-col>
							<div class="d-flex mt-3">
								<span class="viewcon-option-clr"
									>Set Configuration: <span class="asterik">*</span></span
								>
								<b-form-radio-group
									class="ml-3"
									v-model="clone.configSelection"
									:options="setConfigOptions"
									value-field="item"
									text-field="name"
									size="sm"
								></b-form-radio-group>
							</div>
						</b-col>
					</b-row>

					<!-- Selected config display (test mode only) -->
					<div
						v-if="
							mode === 'test' &&
								clone.config &&
								clone.config.configName &&
								clone.configSelection == 'manual'
						"
						class="d-flex justify-content-between mt-4"
					>
						<div
							class="selected-config d-flex align-items-center justify-content-between mr-4"
						>
							<div class="color-mainblue">{{ clone.config.configName }}</div>
							<div class="color-green">Configured</div>
						</div>
						<div
							@click="showViewConfigModal = true"
							class="d-flex align-items-center gap-1 color-mainblue pointer"
						>
							<img
								src="../../../assets/common-icons/changeconfig.svg"
								alt=""
							/>Change
						</div>
					</div>

					<!-- Footer buttons -->
					<div class="d-flex justify-content-end mt-3">
						<b-button class="new-cancelBtn mr-2" @click="closeModal()">
							Cancel
						</b-button>
						<b-button class="new-addBtn" @click="onSaveClick">
							{{
								mode === "test" &&
								clone.publicAvailability &&
								clone.configSelection !== "auto" &&
								!(clone.config && clone.config.configName)
									? "Next"
									: "Save"
							}}
						</b-button>
					</div>
				</div>
			</b-overlay>
		</b-modal>

		<!-- Config Expired Modal (test mode only) -->
		<b-modal
			v-if="mode === 'test'"
			id="PA-ConfigExpiredModal"
			v-model="showExpiredModal"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
		>
			<div class="d-flex align-items-start">
				<div>
					<img src="../../../assets/common-icons/warn-modal.svg" alt="" />
				</div>
				<div class="flex-1 pl-3">
					<div class="d-flex justify-content-between">
						<span class="font-lato fw-500 fs-18"
							>You are selecting an expired Configuration
						</span>
						<img
							@click="showExpiredModal = false"
							class="rotate-on-hover pointer"
							src="../../../assets/common-icons/blue-cross.svg"
							alt=""
						/>
					</div>
					<div class="font-mont fs-13 fw-500 color-344054 mt-2">
						You have to edit the start and end date of the configuration to
						continue the selection
					</div>
				</div>
			</div>
			<div class="d-flex justify-content-end pt-3 gap-3">
				<b-button @click="showExpiredModal = false" class="new-cancelBtn mt-1"
					>Cancel</b-button
				>
				<b-button
					class="new-addBtn mt-1"
					@click="editUsingConfig(expiredConfigID)"
					>Edit</b-button
				>
			</div>
		</b-modal>

		<AddConfigModal
			v-if="mode === 'test' && showAddConfigModal"
			:showModal="showAddConfigModal"
			:editConfigID="editConfigID"
			:viewConfigID="viewConfigID"
			@update-config="updateConfigValue"
			@change-selected-config="changeSelectedConfig"
			@close-modal="resetAll"
		/>
		<ViewAllConfigModal
			v-if="mode === 'test' && showViewConfigModal"
			:showModal="showViewConfigModal"
			:newConfigID="newConfigID"
			:updateConfig="updateConfig"
			:preSelectedConfigId="preSelectedConfigId"
			:resetTrigger="resetTrigger"
			@close-modal="showViewConfigModal = false"
			@expired-warning="openExpiredModal"
			@post-config="postConfig"
			@add-config="addConfig"
			@edit-config="editUsingConfig"
			@view-config="viewConfig"
		/>
	</div>
</template>

<script>
import {
	putTest,
	editProject,
	getGatewayCharges,
	getTagline,
} from "../../../utils/apiFunctions.js";
import {
	between,
	helpers,
	requiredIf,
	minValue,
} from "vuelidate/lib/validators";
import { mapGetters } from "vuex";
import ViewAllConfigModal from "@/components/modals/ViewAllConfigModal.vue";
import AddConfigModal from "@/components/modals/AddConfigModal.vue";
import successToast from "@/views/mixin/toast.js";
import errorToast from "@/views/mixin/toast";
const maxFiveDecimals = helpers.withParams(
	{ type: "maxFiveDecimals" },
	(value) => {
		if (!helpers.req(value)) return true;
		const str = value.toString();
		if (!str.includes(".")) return true;
		return str.split(".")[1].length <= 5;
	}
);

export default {
	name: "PublicAvailability",
	mixins: [successToast, errorToast],
	components: {
		ViewAllConfigModal,
		AddConfigModal,
	},
	props: {
		showModal: {
			type: Boolean,
			default: false,
		},
		// mode: 'test' (default) or 'project'
		mode: {
			type: String,
			default: "test",
		},
		// Used when mode === 'test'
		testDetails: {
			type: Object,
			default: null,
		},
		topicID: {
			type: String,
			default: "",
		},
		// Used when mode === 'project'
		projectDetails: {
			type: Object,
			default: null,
		},
	},
	data() {
		return {
			localModal: false,
			clone: {
				publicAvailability: false,
				setPricing: false,
				listPrice: null,
				discountAmount: null,
				leaderboard: false,
				leaderboardCategory: null,
				configSelection: "auto",
				config: null,
				tagline: "",
			},
			options: [
				{ item: true, name: "Yes" },
				{ item: false, name: "No" },
			],
			setConfigOptions: [
				{ item: "auto", name: "Auto" },
				{ item: "manual", name: "Manual" },
			],
			leaderBoardoptions: [
				{ value: "technical", text: "Technical" },
				{ value: "nontechnical", text: "Non-Technical" },
				{ value: "communication", text: "Communication" },
			],
			openLeaderBoardDropdown: false,
			showViewConfigModal: false,
			showAddConfigModal: false,
			showExpiredModal: false,
			expiredConfigID: "",
			viewConfigID: "",
			editConfigID: "",
			newConfigID: "",
			resetTrigger: null,
			updateConfig: false,
			gatewayPercent: 0,
			gatewayConfig: {},
			loadingShow: false,
			saveLoading: false,
		};
	},
	validations: {
		clone: {
			listPrice: {
				required: requiredIf(function() {
					return this.clone.setPricing;
				}),
				maxFiveDecimals,
				between: between(0, 100000),
			},
			discountAmount: {
				minValue: minValue(0),
				maxFiveDecimals,
				notGreaterThanList: helpers.withParams(
					{ type: "notGreaterThanList" },
					function(value) {
						if (!helpers.req(value)) return true;
						return Number(value) < Number(this.clone.listPrice);
					}
				),
			},
			leaderboardCategory: {
				required: requiredIf(function() {
					return this.clone.leaderboard;
				}),
			},
			tagline: {
				required: requiredIf(function() {
					return this.clone.publicAvailability;
				}),
			},
		},
	},
	computed: {
		// Single source of entity data regardless of mode
		entityDetails() {
			return this.mode === "project" ? this.projectDetails : this.testDetails;
		},
		priceAfterDiscount() {
			if (!this.clone.listPrice) return 0;
			return this.clone.listPrice - (this.clone.discountAmount || 0);
		},
		gatewayAmount() {
			return (this.priceAfterDiscount * this.gatewayPercent) / 100;
		},
		finalReceivable() {
			return this.priceAfterDiscount - this.gatewayAmount;
		},
		preSelectedConfigId() {
			return this.clone.config ? this.clone.config.configID : null;
		},
		...mapGetters("userVUEX", {
			leaderboardAdminAccess: "getleaderboardAdminAccess",
		}),
	},
	watch: {
		showModal: {
			immediate: true,
			handler(val) {
				this.localModal = val;
				if (val) {
					this.initClone();
					this.getGatewayCharges();
				}
			},
		},
		localModal(val) {
			if (!val) this.$emit("hide");
		},
		"clone.configSelection"() {
			if (this.clone.configSelection === "auto") {
				this.clone.config = null;
			}
		},
	},
	methods: {
		async fetchTagline() {
			try {
				this.loadingShow = true;
				const response = await getTagline(this.entityDetails.testID);
				if (response.status === 200) {
					this.clone.tagline = response.data.data.tagline;
				} else {
					this.errorToast("Failed to generate tagline");
				}
			} catch (error) {
				this.errorToast("Error generating tagline");
				console.error(error);
			} finally {
				this.loadingShow = false;
			}
		},
		initClone() {
			this._savedPublicData = null;
			const d = this.entityDetails;
			this.clone = {
				publicAvailability: d.publicAvailability || false,
				setPricing: d.setPricing || false,
				listPrice: d.listPrice || null,
				discountAmount: d.discountAmount || null,
				leaderboard: d.leaderboard || false,
				leaderboardCategory: d.leaderboardCategory || null,
				// config fields only relevant for test mode
				configSelection: d.configSelection || "auto",
				config: d.config ? { ...d.config } : null,
				tagline: d.tagline || "",
			};
			this.$v.$reset();
		},
		onPublicAvailabilityChange() {
			if (!this.clone.publicAvailability) {
				this._savedPublicData = {
					leaderboard: this.clone.leaderboard,
					leaderboardCategory: this.clone.leaderboardCategory,
					setPricing: this.clone.setPricing,
					listPrice: this.clone.listPrice,
					discountAmount: this.clone.discountAmount,
					configSelection: this.clone.configSelection,
					config: this.clone.config ? { ...this.clone.config } : null,
					tagline: this.clone.tagline,
				};
				this.clone.leaderboard = false;
				this.clone.leaderboardCategory = null;
				this.clone.setPricing = false;
				this.clone.listPrice = null;
				this.clone.discountAmount = null;
				this.clone.configSelection = "auto";
				this.clone.config = null;
			} else if (this._savedPublicData) {
				const s = this._savedPublicData;
				this.clone.leaderboard = s.leaderboard;
				this.clone.leaderboardCategory = s.leaderboardCategory;
				this.clone.setPricing = s.setPricing;
				this.clone.listPrice = s.listPrice;
				this.clone.discountAmount = s.discountAmount;
				this.clone.configSelection = s.configSelection;
				this.clone.config = s.config ? { ...s.config } : null;
				this.clone.tagline = s.tagline;
				this._savedPublicData = null;
			}
		},
		onLeaderboardChange() {
			if (!this.clone.leaderboard) {
				this.clone.leaderboardCategory = null;
				this.openLeaderBoardDropdown = false;
			}
		},
		hideshowPricingDetails() {
			if (this.clone.setPricing) {
				this.clone.discountAmount = 0;
			} else {
				this.clone.listPrice = null;
				this.clone.discountAmount = null;
			}
		},
		closeLeaderBoardDropdown() {
			this.openLeaderBoardDropdown = false;
		},
		onSaveClick() {
			if (
				this.mode === "test" &&
				this.clone.publicAvailability &&
				this.clone.configSelection !== "auto" &&
				!(this.clone.config && this.clone.config.configName)
			) {
				this.openViewAllConfigModal();
			} else {
				this.savePublicAvailability();
			}
		},
		openViewAllConfigModal() {
			this.$v.clone.$touch();
			if (!this.$v.clone.$invalid) {
				this.showViewConfigModal = true;
			}
		},
		postConfig(config) {
			this.clone.config = {
				configName: config.configName,
				configID: config.configID,
			};
			this.showViewConfigModal = false;
		},
		async savePublicAvailability() {
			this.$v.clone.$touch();

			if (Number(this.clone.discountAmount) < 0) {
				this.errorToast("Please don't enter a negative number");
				return;
			}
			if (
				this.clone.discountAmount &&
				Number(this.clone.discountAmount) >= Number(this.clone.listPrice)
			) {
				this.errorToast("Discount cannot be greater or equal than list price");
				return;
			}
			if (this.$v.clone.$invalid) {
				this.errorToast("Please fill all the mandatory fields");
				return;
			}

			this.saveLoading = true;
			try {
				let response;

				if (this.mode === "project") {
					// Project mode: use editProject with full payload (same as CreateProject edit)
					const d = this.entityDetails;
					const payload = {
						name: d.name,
						portion: "SandboxProject",
						templateID: d.templateID,
						description: d.description,
						categoryID: d.categoryID,
						subCategoryID: d.subCategoryID,
						averageDifficulty: d.averageDifficulty,
						marks: d.marks,
						tags: d.tags,
						checkingMetrics: d.checkingMetrics,
						active: d.active,
						publicAvailability: this.clone.publicAvailability,
						tagline: this.clone.tagline,
						setPricing: this.clone.setPricing,
					};
					if (this.clone.setPricing) {
						payload.pricingDetails = {
							pricingType: 1,
							listPrice: Number(this.clone.listPrice),
							discountAmount: Number(this.clone.discountAmount),
						};
					}
					response = await editProject(d.testID, payload);
				} else {
					// Test mode: use putTest
					let payload = {
						topicID: this.topicID,
						testID: this.testDetails.testID,
						name: this.testDetails.name,
						publicAvailability: this.clone.publicAvailability,
						categoryID: this.testDetails.categoryID,
						subCategoryID: this.testDetails.subCategoryID,
						configSelection: this.clone.configSelection,
						configID: this.clone.config?.configID || null,
						tagline: this.clone.tagline,
					};
					if (this.leaderboardAdminAccess) {
						payload.leaderboard = this.clone.leaderboard;
						payload.leaderboardCategory = this.clone.leaderboardCategory;
						payload.setPricing = this.clone.setPricing;
						if (this.clone.setPricing) {
							payload.pricingDetails = {
								pricingType: 1,
								listPrice: Number(this.clone.listPrice),
								discountAmount: Number(this.clone.discountAmount),
							};
						}
					}
					if (!this.clone.publicAvailability) {
						delete payload.configID;
						delete payload.configSelection;
					} else if (this.clone.configSelection === "auto") {
						delete payload.configID;
					}
					response = await putTest({ ...payload });
				}

				if (response.status === 200) {
					this.$emit("updated", {
						testID: this.entityDetails.testID,
						publicAvailability: this.clone.publicAvailability,
						setPricing: this.clone.setPricing,
						leaderboard: this.clone.leaderboard,
						leaderboardCategory: this.clone.leaderboardCategory,
					});
					this.successToast("Public availability updated successfully!");
					this.localModal = false;
				} else if (response.status === 409) {
					this.errorToast(
						this.mode === "project"
							? "Project name already exists"
							: "Test name already exists"
					);
				} else {
					this.errorToast("Something went wrong!");
				}
			} catch (error) {
				this.errorToast("Something went wrong!");
				console.error(error);
			} finally {
				this.saveLoading = false;
			}
		},
		closeModal() {
			this.localModal = false;
			this.$emit("hide");
		},
		getDeviceMode() {
			const ua = navigator.userAgent || navigator.vendor || window.opera;
			if (/android/i.test(ua)) return "ANDROID";
			if (/iPad|iPhone|iPod/.test(ua) && !window.MSStream) return "IOS";
			if (/Mobi|Mobile/.test(ua)) return "MOBILE_WEB";
			return "WEB";
		},
		async getGatewayCharges() {
			try {
				const res = await getGatewayCharges();
				if (res.status == 200) {
					this.gatewayConfig = res.data.data.HIRE3X_FEE;
					const deviceMode = this.getDeviceMode();
					const feeObj = Object.values(this.gatewayConfig).find(
						(f) => f.mode === deviceMode
					);
					this.gatewayPercent = feeObj?.charge || 0;
				}
			} catch (error) {
				console.error(error);
			}
		},
		updateConfigValue() {
			this.updateConfig = true;
		},
		resetAll() {
			this.viewConfigID = "";
			this.editConfigID = "";
			this.resetTrigger = Date.now();
			this.showAddConfigModal = false;
		},
		viewConfig(data) {
			this.viewConfigID = data;
			this.showAddConfigModal = true;
		},
		editUsingConfig(data) {
			this.viewConfigID = "";
			this.editConfigID = data;
			this.showAddConfigModal = true;
			this.showExpiredModal = false;
		},
		changeSelectedConfig(data) {
			this.newConfigID = data;
		},
		addConfig() {
			this.showAddConfigModal = true;
		},
		openExpiredModal(data) {
			this.showExpiredModal = true;
			this.expiredConfigID = data.configID;
		},
	},
};
</script>

<style scoped>
.pricing-container {
	border: 1px solid #d0d5dd80;
	border-radius: 8px;
	padding: 12px;
}
.selected-config {
	background-color: #f7f9fb;
	border-radius: 8px;
	padding: 10px 16px;
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 12px;
	flex: 1;
}
.viewcon-label {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 14px;
	color: #667085;
	background-color: var(--bg-inputfield);
	position: absolute;
	left: 9px;
	top: -12px;
	z-index: 4;
	padding: 0px 7px;
}
</style>
